import React, { Component } from 'react';
import './style.css';
import {Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {androidDelete} from 'react-icons-kit/ionicons/androidDelete';
import {edit} from 'react-icons-kit/ionicons/edit';

class DemographicsSubQuestionList extends Component {
  constructor(props){
    super(props)
    this.state={
    };
   
  }

  addSubQuestion(){
      this.props.showAddSubQuestion();
  }

  softDeleteSubQuestion(data){
    let data1 = {};
    data1.id = data._id;
    data1.cat_id = data.cat_id;
    data1.ques_id = data.ques_id;
    data1.sub_ques_id = data.sub_ques_id;
    this.props.softDeleteSubQuestion(data1);
  }

  backtoPage(){
    window.history.back();
  }

  editSubQuestion(data){
    this.props.editSubQuestion(data);
  }

  render(){
    
    let subQuestionDataList = "";
    if(this.props.demoGraphicsSubQuesOptionsListSuccess){
      
    if(this.props.demoGraphicsSubQuesOptionsListData && this.props.demoGraphicsSubQuesOptionsListData.length > 0){

        let subQuestions = this.props.demoGraphicsSubQuesOptionsListData;
        subQuestionDataList = Object.keys(subQuestions).map((item, index) => {
        let subQuestionItem = subQuestions[item];

        let checkSubQuestion = "";
        if(subQuestionItem.sec_sub_ques){
            checkSubQuestion = "Yes";
        }else{
            checkSubQuestion = "No";
        }

        return <tr key={index} >
            <td style ={{ textAlign : "center" }} >{index+1}</td>
            <td style ={{ textAlign : "center" }} >{subQuestionItem.questions}</td>
            <td style ={{ textAlign : "center" }} >{subQuestionItem.selectionType}</td>
            <td style ={{ textAlign : "center" }} >{subQuestionItem.orderSubQues}</td>
            <td style ={{ textAlign : "center" }} >{checkSubQuestion}</td>
            <td className = "cat_action">
            
            <button onClick = {this.editSubQuestion.bind(this, subQuestionItem)} className = "removebutton">
            < Icon icon={edit} size={30} style={{ color: '#336699' }}/>
            </button>
            <button onClick = {this.softDeleteSubQuestion.bind(this, subQuestionItem)} className = "removebutton">< Icon icon={androidDelete} size={30} style={{ color: '#EF233C' }}/></button>            
            </td>
          </tr>
          });
    }else{
        subQuestionDataList = "No data"
    }
  }

  return (<div className = "userlist">
  <div className = "userlistbackground">
        <div className = "usertable"><h1>Sub Question List</h1></div>
     <button className = "goBackBySubQuestion"   onClick={this.backtoPage.bind(this)}>Back</button>
     <button  className = "addSubQuestionbtn" onClick={this.addSubQuestion.bind(this)}>Add Sub Question</button>
        <div className = "autoscroll">
        <table className = "demoategoryTable">
          <thead>
            <tr >
              <th>Sr.No.</th>
              <th>Question</th>
              <th>SelectionType</th>
              <th>Order No.</th>
              <th>IsSubQuestion</th>
              <th>Action</th> 
            </tr>
          </thead>
            <tbody> 
              {subQuestionDataList}  
            </tbody>
        </table>
        </div>
        </div>
        </div>
        
    );
  }
}
export default DemographicsSubQuestionList;



// WEBPACK FOOTER //
// ./src/components/demographics/subQuestionList.js